import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

const marker = $('#marker');

if( $('.mapbox-single') ) {
    if ( marker.attr( 'data-lng' ) ) {
        var markerPosition = new mapboxgl.LngLat( marker.attr( 'data-lng' ), marker.attr( 'data-lat' ) );
        mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsOTZ3bnNobTA4OXgzcGx3Zm1tMGJnbDgifQ.2qBdn_faKtFuQ1AJpsWsaA';

        let zoom;
        if( $('.mapbox-single').hasClass('mapbox-single--wonen')) {
            zoom = 15;
        } else {
            zoom = 10;
        }

        var map = new mapboxgl.Map({
            container: 'mapboxSingle',
            style: 'mapbox://styles/blackdesk/ckxrlu6g5sm3h15nsz7ftyzrg',
            center: markerPosition,
            maxZoom: 18,
            zoom: zoom,
        });

        var newMarker = document.createElement( 'div' );
        newMarker.className = 'marker';
        newMarker.style.backgroundImage = 'url(/wp-content/uploads/2022/10/marker.svg)';
        newMarker.style.width = '49px';
        newMarker.style.height = '70px';
        newMarker.style.marginTop = '-29px';
        newMarker.backgroundSize = 'cover';

        if( $('.mapbox-single').hasClass('mapbox-single--wonen')) {
            map.scrollZoom.disable();
        }

        new mapboxgl.Marker(newMarker)
        .setLngLat( markerPosition )
        .addTo( map );

        map.on( 'load', function() {
            map.resize();
        });
    }
}

// Contact maps
if( $('.mapbox-single--contact').length != 0 ) {
    if ( marker.attr( 'data-lng' ) ) {
        var markerPositionContact = new mapboxgl.LngLat( marker.attr( 'data-lng' ), marker.attr( 'data-lat' ) );
        mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsOTZ3bnNobTA4OXgzcGx3Zm1tMGJnbDgifQ.2qBdn_faKtFuQ1AJpsWsaA';

        let zoom;
        if( $('.mapbox-single--contact').hasClass('mapbox-single--wonen')) {
            zoom = 15;
        } else {
            zoom = 10;
        }

        var mapContact = new mapboxgl.Map({
            container: 'mapboxSingleContact',
            style: 'mapbox://styles/blackdesk/ckxrlu6g5sm3h15nsz7ftyzrg',
            center: markerPositionContact,
            maxZoom: 18,
            zoom: zoom,
        });

        var el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage = 'url(/wp-content/uploads/2022/10/marker.svg)';
        el.style.width = '49px';
        el.style.height = '70px';
        el.style.marginTop = '-29px';
        el.backgroundSize = 'cover';

        mapContact.scrollZoom.disable();

        new mapboxgl.Marker(el)
        .setLngLat( markerPositionContact )
        .addTo( mapContact );

        mapContact.on( 'load', function() {
            mapContact.resize();
        });
    }
}
